import { useLocation } from "react-router-dom";

/** Navigation state a user list hands its invite form so it returns to the same filtered list
 * (minus a stale `org`, which is no longer a filter). */
export const fromList = (listSearch: string) => {
  const params = new URLSearchParams(listSearch);
  params.delete("org");
  const query = params.toString();
  return { listSearch: query ? `?${query}` : "" };
};

/** `listPath` plus the search string of the list that opened this form. */
export function useListPath(listPath: string): string {
  const { state } = useLocation();
  const listSearch = (state as { listSearch?: unknown } | null)?.listSearch;
  // Only a query string: history state is page-controlled and must not steer the path.
  const isQuery = typeof listSearch === "string" && listSearch.startsWith("?");
  return `${listPath}${isQuery ? listSearch : ""}`;
}
